import React from "react";
import Dashboard from "@/components/dashboard";
import MainTable from "@/components/common/MainTable";
import CostAddForm from "@/components/dashboard/menu/Cost/CostAddForm";
import {
  deleteCostAsync,
  getAllCostAsync,
  getCostData,
} from "@/redux/slices/costSlice";
import { useAppDispatch, useAppSelector } from "@/redux/hooks";
import { formatDate } from "@/utils";

interface Data {
  _id: string;
  no: number;
  companyName: string;
  bankName: String;
  chequeNo: string;
  amount: number;
  date: number;
  purpose: string;
  photo: string;
  pdf: string;
  note: string;
}

// interface HeadCell {
//   id: string;
//   label: string;
//   name: string;
//   numeric: boolean;
//   disablePadding: boolean;
// }

const headCells = [
  {
    id: "0",
    label: "#",
    name: "no",
    numeric: false,
    disablePadding: false,
  },
  {
    id: "1",
    label: "Company",
    name: "companyName",
    numeric: false,
    disablePadding: false,
  },
  {
    id: "2",
    label: "Bank Name",
    name: "bankName",
    numeric: false,
    disablePadding: false,
  },
  {
    id: "3",
    label: "Check No",
    name: "chequeNo",
    numeric: false,
    disablePadding: false,
  },
  {
    id: "4",
    label: "Amount",
    name: "amount",
    numeric: true,
    disablePadding: false,
  },

  {
    id: "5",
    label: "Purpose",
    name: "purpose",
    numeric: false,
    disablePadding: false,
  },
  {
    id: "6",
    label: "Date",
    name: "date",
    numeric: false,
    disablePadding: false,
  },
  {
    id: "7",
    label: "Photo",
    name: "photo",
    numeric: false,
    disablePadding: false,
  },
  {
    id: "8",
    label: "PDF Link",
    name: "pdf",
    numeric: false,
    disablePadding: false,
  },
  {
    id: "9",
    label: "Note",
    name: "note",
    numeric: false,
    disablePadding: false,
  },
];

const Cost = () => {
  const dispatch = useAppDispatch();
  const { data }: any = useAppSelector(getCostData);
  const [rows, setRows] = React.useState<Data[]>([]);

  React.useEffect(() => {
    const fetchData = async () => {
      await dispatch(getAllCostAsync());
    };
    fetchData();
  }, [dispatch]);

  React.useEffect(() => {
    if (data && data.length > 0) {
      const newData = data.map((item: any, i: number) => {
        const {
          _id,
          company,
          bank,
          chequeNo,
          amount,
          date,
          purpose,
          photo,
          pdf,
          note,
        } = item;
        return {
          _id,
          no: i + 1,
          companyName: company?.companyName || "",
          bankName: bank?.bankName || "",
          chequeNo,
          amount,
          date: formatDate(date),
          purpose: purpose?.purposeTitle || "",
          photo,
          pdf,
          note,
        };
      });
      setRows(newData);
    } else {
      setRows([]);
    }
  }, [data]);

  return (
    <Dashboard>
      <MainTable
        tableName="Cost Amount List"
        headCells={headCells}
        rows={rows}
        modalTitle="Cost"
        form={CostAddForm}
        deleteFunc={deleteCostAsync}
      />
    </Dashboard>
  );
};

export default Cost;
